import { render, staticRenderFns } from "./DataPropertyImplementationTable.vue?vue&type=template&id=3a687fba&"
import script from "./DataPropertyImplementationTable.vue?vue&type=script&lang=js&"
export * from "./DataPropertyImplementationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports